<template>
  <div class="imgsort-list">
    <div class="label-search-wrap" @click.stop :class="{ 'all-show': allTagShow }">
      <div class="label-search">
        <div class="showAllBtn" @click="allTagShow = !allTagShow">
          <i :class="allTagShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
        <div class="tag-list" :class="{ 'all-tag-show': allTagShow }">
          <el-tag
            v-for="item in tagList"
            :key="item.tagId"
            @click="getImgListByTag(item)"
            :effect="item.selected ? 'dark' : 'plain'"
          >
            {{ item.tagName }}
          </el-tag>
        </div>
      </div>
    </div>
    <div class="page-filter">
      <div class="condition-wrap">
        <span class="condition-label">国家</span>
        <el-select v-model="countryType">
          <div v-for="item in countryList" :key="item.value">
            <el-option :label="item.name" :value="item.value"></el-option>
          </div>
        </el-select>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">数据类型</span>
        <el-select :disabled="isBrand" v-model="dataType" @change="dataChange">
          <div v-for="item in dataTypeList" :key="item.value">
            <el-option :label="item.name" :value="item.value"></el-option>
          </div>
        </el-select>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">店铺ID</span>
        <el-input
          class="w200"
          style="width:200px;"
          @blur="shopBlur"
          :disabled="dataType == 1 || isBrand"
          v-model="shopId"
          placeholder="请输入店铺ID"
        ></el-input>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">ip分类</span>
        <el-select
          :loading="categoryLoading"
          clearable
          :disabled="categoryDisabled"
          v-model="categoryId"
        >
          <el-option label="全部" value=""></el-option>
          <div v-for="item in categoryList" :key="item.categoryId">
            <el-option :label="item.categoryName" :value="item.categoryId"></el-option>
          </div>
        </el-select>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">内容</span>
        <el-input
          class="w200"
          style="width:200px;"
          v-model="content"
          placeholder="ip名字/关键词/作者"
        ></el-input>
      </div>
      <div class="condition-wrap">
        <el-button type="primary" @click="btnGetImgList">筛选</el-button>
      </div>
    </div>
    <div class="img-list">
      <div class="item" v-for="(item, index) in imgList" :key="item.designId">
        <div class="img-wrap" @click="showImg(item)">
          <img :src="item.designUrl + '?x-oss-process=image/resize,w_200'" alt="" />
        </div>
        <div class="text">
          <div class="text-label">作者:</div>
          <div class="text-value">{{ item.authorName }}</div>
        </div>
        <div class="text">
          <div class="text-label">IP名称：</div>
          <div class="text-value">{{ item.name }}</div>
        </div>
        <div class="text">
          <div class="text-label">国家：</div>
          <div class="text-value">{{ countryObj[item.countryType] }}</div>
        </div>
        <div class="btn-gourp">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-download"
            @click="download(item.designPdf, item.designId)"
            >保存</el-button
          >
          <el-button
            v-if="shopId != item.shopId"
            type="primary"
            size="small"
            icon="el-icon-goods"
            @click="buyCommon(item)"
            >购买授权</el-button
          >
        </div>
      </div>
    </div>
    <div class="site-page">
      <el-pagination
        background
        :page-count="totalPage"
        :current-page="pageNum"
        @current-change="getImgList"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <el-dialog
      width="500px"
      title="防伪码选择"
      :visible.sync="innerVisible"
      @close="clearBuyOption"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="buy-option">
        <div class="title">防伪码区域</div>
        <el-radio-group v-model="buyOption.code">
          <el-radio-button label="1">国内防伪码</el-radio-button>
          <el-radio-button label="2">国外防伪码</el-radio-button>
        </el-radio-group>
      </div>
      <div class="buy-option">
        <div class="title" style="margin-top:20px;">购买数量</div>
        <el-input-number
          v-model="buyOption.num"
          :min="1"
          style="width:192px;"
          @change="numChange"
        ></el-input-number>
      </div>
      <div class="buy-option">
        <div class="title" style="margin-top:20px;">总价</div>
        <div class="totalPrice" style="color:#409EFF;">￥{{ buyOption.total }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false">取 消</el-button>
        <el-button type="primary" @click="buy">立即购买</el-button>
      </span>
    </el-dialog>
    <el-dialog title="" :visible.sync="dialogVisible" width="500px">
      <!-- <div slot="title">
        <el-button type="info" @click="download" class="my-btn-black">下载<i class="el-icon-download el-icon--right"></i></el-button>
      </div> -->
      <!-- <div class="currentImg" :style="{background: `url('${currentItem.designUrl}') no-repeat center center / contain`}"> -->
      <div class="currentImg">
        <img :key="currentItem.designId" :src="currentItem.designUrl" alt="" />
      </div>
      <el-tabs class="my-tab" v-model="activeName">
        <el-tab-pane label="IP介绍" name="first">
          <div class="authorDesc">
            <div class="name" style="margin-top:0; margin-bottom:5px;">{{ currentItem.name }}</div>
            <!-- <div class="price">￥{{currentItem.price}}</div> -->
            <div class="countryType">
              所属国家：{{ currentItem.countryType == 2 ? '国内' : '国外' }}
            </div>
            <div class="copyright">
              版权归属：{{ currentItem.authorInfo || currentItem.author.authorName }}
            </div>
            <div class="categoryName">分类：{{ currentItem.category.categoryName || '暂无' }}</div>
            <div class="categoryName">授权品类：{{ currentItem.extAuthTypeNames.join('、') }}</div>
            <div class="categoryName">
              设计要求：{{ currentItem.designRequirementName
              }}{{ currentItem.designRequirement ? `(${currentItem.designRequirement})` : '' }}
            </div>
            <div class="categoryName">推广应用：{{ currentItem.extensionAppNames.join('、') }}</div>
            <div class="name" style="margin-bottom:2px;">简介</div>
            <div v-if="currentItem.remark" class="desc">{{ currentItem.remark }}</div>
            <div v-else class="no-data">暂无简介</div>
            <div class="btn-gourp" style="width:300px;margin: 20px auto 0;">
              <el-button
                type="primary"
                size="small"
                icon="el-icon-download"
                @click="download(currentItem.designPdf, currentItem.designId)"
                >保存图片</el-button
              >
              <el-button
                v-show="currentItem.introduceFile"
                type="primary"
                size="small"
                icon="el-icon-download"
                @click="download(currentItem.introduceFile)"
                >下载文案</el-button
              >
              <el-button
                type="primary"
                size="small"
                icon="el-icon-search"
                @click="searchAll(currentItem.author.authorId)"
                >作者全部IP</el-button
              >
              <el-button
                type="primary"
                v-if="shopId != currentItem.shopId"
                size="small"
                icon="el-icon-goods"
                @click="buyCommon(currentItem)"
                >购买授权</el-button
              >
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="作者介绍" name="second">
          <div class="authorDesc">
            <div class="author-info">
              <div class="author-pic">
                <img
                  v-if="currentItem.author.authorPic"
                  :src="currentItem.author.authorPicUrl"
                  alt=""
                />
                <img v-else src="../assets/author.png" alt="" />
              </div>
              <div class="author-text">
                <div class="author-name">{{ currentItem.author.authorName }}</div>
                <div class="author-country">
                  所属国家：{{ currentItem.author.countryType == 2 ? '国内' : '国外' }}
                </div>
              </div>
            </div>
            <div class="name" style="margin-bottom:2px; margin-top:0;">简介</div>
            <div v-if="currentItem.author.remark" class="desc">{{ currentItem.author.remark }}</div>
            <div v-else class="no-data">暂无简介</div>
            <div class="btn-gourp" style="width:300px;margin: 20px auto 0;">
              <el-button
                v-if="currentItem.author.vedioSource"
                type="primary"
                size="small"
                icon="el-icon-download"
                @click="download(currentItem.author.vedioSource)"
                >下载作者介绍</el-button
              >
              <el-button
                v-if="shopId != currentItem.shopId"
                type="primary"
                size="small"
                icon="el-icon-goods"
                @click="innerVisible = true"
                >购买授权</el-button
              >
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- <div v-if="currentItem.introduceFile" class="browse">
        <div class="name"><i class="el-icon-document"></i>{{currentItem.introduceFile.split('/').pop()}}</div>
        <el-button type="primary" size="mini" @click="download(currentItem.introduceFile)">下载</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import API, { baseUrl } from '../lib/API'
import { dataTypeList, countryList } from '../lib/constObj.js'
export default {
  name: 'OrderList',
  data() {
    return {
      pageNum: 1,
      totalPage: 0,
      content: '',
      categoryId: '',
      isBrand: true,
      innerVisible: false,
      shopId: '',
      categoryLoading: false,
      countryList: countryList,
      dataTypeList: dataTypeList,
      name: '',
      imgList: [],
      dialogVisible: false,
      currentImg: '',
      activeName: 'first',
      countryType: '1',
      dataType: '1',
      countryObj: {},
      categoryList: [],
      buyCurrentItem: {},
      currentItem: {
        introduceFile: '',
        author: {},
        extAuthTypeNames: [],
        extensionAppNames: [],
        category: {}
      },
      buyOption: {
        code: '',
        num: 1,
        price: 1,
        total: 1 * 1
      },
      tagList: [],
      allTagShow: false,
      mode: 1, //0: 点选标签查询，1：搜索条件查询
      selectedTagName: '',
      clickCb: () => {
        this.allTagShow = false
      },
      designRequirementList: [],
      authCategoryList: [],
      appList: []
    }
  },
  computed: {
    categoryDisabled() {
      if (this.dataType === '1' || (this.dataType === '2' && this.shopId)) {
        return false
      }
      return true
    }
  },
  methods: {
    clearSelected() {
      this.selectedTagName = ''
      this.tagList.forEach(item => {
        item.selected = false
      })
    },
    numChange(num) {
      this.buyOption.total = this.buyOption.price * (num || 0)
    },
    getImgListByTag(item) {
      this.clearSelected()
      this.selectedTagName = item.tagName
      item.selected = true
      this.tagSelectGetImgList()
    },
    dealObj() {
      this.countryList.forEach(item => {
        this.countryObj[item.value] = item.name
      })
    },
    searchAll(authorId) {
      this.$router.push({ name: 'AuthorAllDesign', query: { authorId } })
    },
    buyCommon(item) {
      this.buyCurrentItem = item
      this.buyOption.price = item.price
      this.innerVisible = true
    },
    shopBlur() {
      if (this.shopId) {
        this.getCategoryList()
      }
    },
    dataChange() {
      this.shopId = ''
      this.categoryList = []
      this.categoryId = ''
      if (this.dataType === '1') {
        this.getCategoryList()
      }
    },
    buy() {
      if (!this.buyOption.num) return this.$message.error('请输入购买数量')
      if (!this.buyOption.code) return this.$message.error('请选择防伪码区域')
      console.log(this.buyCurrentItem)
      // return
      this.$router.push({
        name: 'OrderConfirm',
        query: {
          count: this.buyOption.num,
          total: this.buyOption.total,
          code: this.buyOption.code,
          price: this.buyCurrentItem.price,
          designId: this.buyCurrentItem.designId,
          ipImgUrl: this.buyCurrentItem.designUrl + '?x-oss-process=image/resize,w_200'
        }
      })
    },
    download(designPdf, designId) {
      let a = document.createElement('a')
      a.href = `${baseUrl}/download/image?key=${designPdf}&designId=${designId ||
        ''}&accesstoken=${localStorage.getItem('token')}`
      a.click()
    },
    getTagList() {
      new API(this).POST({
        url: '/tag/findTagList',
        cb: res => {
          res.forEach(item => {
            item.selected = false
          })
          this.tagList = res
        }
      })
    },
    getCategoryList() {
      this.categoryLoading = true
      // 图案分类
      new API(this).POST({
        url: '/designCategory/findAllEndableDesignCategoryList',
        params: {
          dataType: this.dataType,
          shopId: this.shopId
        },
        cb: res => {
          this.categoryList = res
          this.categoryLoading = false
        }
      })
    },
    showImg(item) {
      this.activeName = 'first'
      this.buyOption.price = item.price || 1
      this.dialogVisible = true
      new API(this).POST({
        url: '/design/getDesignDetail?designId=' + item.designId,
        cb: res => {
          res.author = res.author || {}
          this.currentItem = res
        }
      })
    },
    clearBuyOption() {
      this.buyOption = {
        code: '',
        num: 1,
        price: 1,
        total: 1 * 1
      }
    },
    btnGetImgList() {
      this.clearSelected()
      this.mode = 1
      this.getImgList()
    },
    tagSelectGetImgList() {
      this.mode = 0
      this.getImgList()
    },
    getImgList(val) {
      if (!isNaN(val)) {
        this.pageNum = val
      } else {
        this.pageNum = 1
      }
      let params = {}
      if (this.mode) {
        params = {
          categoryId: this.categoryId,
          count: true,
          pageNum: this.pageNum,
          pageSize: 50,
          countryType: this.countryType,
          searchContent: this.content,
          shopId: this.shopId,
          dataType: this.dataType
        }
      } else {
        params = {
          count: true,
          pageNum: this.pageNum,
          pageSize: 50,
          shopId: this.shopId,
          searchContent: this.selectedTagName,
          dataType: this.dataType
        }
      }
      new API(this).POST({
        url: '/design/listWithPage',
        params,
        cb: res => {
          let { pages, result } = res
          result.forEach(element => {
            element.load = false
          })
          this.totalPage = pages
          this.imgList = result
          document.getElementById('index-page').scrollTop = 0
        }
      })
    }
  },
  created() {
    this.dealObj()

    this.isBrand = localStorage.getItem('roleId') === '4'
    if (this.isBrand) {
      this.shopId = localStorage.getItem('shopId')
      this.dataType = '2'
    }
    this.getCategoryList()
    this.getTagList()
    this.getImgList()
    document.addEventListener('click', this.clickCb)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickCb)
  }
}
</script>
<style scoped lang="less">
.showAllBtn {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 5px;
  top: 20px;
  width: 40px;
  height: 40px;
  font-size: 24px;
  color: #409eff;
  cursor: pointer;
}
.all-show {
  .label-search {
    background: #fafafa;
    box-shadow: 0 2px 5px 5px rgba(0, 0, 0, 0.1);
  }
}
.label-search-wrap {
  width: 100%;
  height: 82px;
  position: relative;
  padding: 0 20px;
  margin-bottom: 10px;
  box-sizing: border-box;
}
.label-search {
  box-sizing: border-box;
  z-index: 999;
  transition: all 0.3s;
  width: 100%;
  padding: 20px 45px 20px;
  background: #fafafa;
  position: absolute;
  left: 0;
  top: 0;
}
.tag-list {
  max-height: 42px;
  transition: all 0.4s;
  overflow: hidden;
  /deep/ .el-tag {
    margin: 5px 10px;
    cursor: pointer;
  }
}
.all-tag-show {
  max-height: 500px;
}
.my-tab /deep/ .el-tabs__item {
  width: 50%;
  text-align: center;
  font-size: 18px;
}
.my-tab /deep/ .el-tabs__nav {
  width: 100%;
}
.currentImg {
  width: 100%;
  // height: 500px;
  // border: 1px solid #f1f1f1;
  img {
    width: 100%;
  }
}
.buy-option {
  margin-bottom: 20px;
}
.title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
}
.btn-gourp {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
.my-btn-black {
  background: #000;
}
.authorDesc {
  line-height: 34px;
  color: rgb(85, 83, 83);
  font-size: 16px;
  padding: 5px 10px;
  .name {
    font-weight: bold;
    font-size: 18px;
    color: #000;
    margin: 10px 0;
  }
  .price {
    color: orange;
  }
  .desc {
    background: #f1f1f1;
    padding: 10px;
    border-radius: 8px;
    margin: 6px 0 0;
  }
  .author-info {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .author-pic {
      width: 60px;
      height: 60px;
      margin-right: 15px;
      img {
        width: 100%;
        height: 100%;
      }
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
    .author-text {
      .author-name {
        font-weight: bold;
        font-size: 16px;
        color: #000;
      }
    }
  }
}
.browse {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 5px 10px;
  margin-bottom: 20px;
  border-radius: 5px;
  margin-top: 10px;
  .name {
    width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  i {
    margin-right: 10px;
  }
}
.img-list {
  display: flex;
  flex-wrap: wrap;
  .item {
    width: 19%;
    cursor: pointer;
    transition: all 0.4s;
    // background: #f1f1f1;
    border: 1px solid #ccc;
    border-radius: 10px;
    box-sizing: border-box;
    margin: 0.5%;
    padding: 10px 20px;
    .img-wrap {
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: center;
      border: 10px solid #f1f1f1;
      background: #f1f1f1;
      box-sizing: border-box;
      margin-bottom: 10px;
      img {
        height: 200px;
        display: block;
        display: block;
      }
    }
    .text {
      display: flex;
      line-height: 30px;
      .text-label {
        width: 60px;
      }
      .text-value {
        width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    &:hover {
      box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/IpList.vue